import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"
import moment from 'moment';

export default {
    data() {
        return {
            orgId: '',
            formInline: {
                numberType: '',
                number: '',
                
            },
            changeValue: [],
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            },
            {
                value: '3',
                label: this.$t('common.manufactureNum')
            },
            {
                value: '4',
                label: this.$t('common.customNum')
            }],
            
            height: '500',
            list: [],
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10,
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    created() {
        this.getDate()
    },
    methods: {
        getDate() {
            const endTime = moment().subtract(1, "day").format("YYYY-MM-DD");
            const startTime = moment().subtract(1, "month").format("YYYY-MM-DD");
            this.changeValue = [startTime, endTime];
        },
        changeTime() {
            this.getMonthOrderList()
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 1,
                startTime: this.changeValue[0],
                endTime: this.changeValue[1],
                selectCarType: this.formInline.numberType,
                selectCarValue: this.formInline.number
            };
            this.$store.dispatch('checkManagement/GET_QUERYSPOTCHECKREPORT', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.label.map((item, index) => {
                            if (item.label == this.$t('SafeManagement.totalWorkTime')) {
                                item.width = ''
                                item.align = 'center'
                            } else {
                                item.align = 'center'
                                item.width = '120'
                            }

                        })
                        this.columns = res.data.data.label
                        this.list = res.data.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline.numberType = ''
            this.formInline.number = ''
            this.getDate()
            this.getMonthOrderList()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportSpotCheckReport?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}&selectCarType=${this.formInline.numberType}&selectCarValue=${this.formInline.number}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportSpotCheckReport?orgId=${this.orgId}&selectType=${1}&startTime=${this.changeValue[0]}&endTime=${this.changeValue[1]}&selectCarType=${this.formInline.numberType}&selectCarValue=${this.formInline.number}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList()
        },
    }
}
